import { Component, ElementRef, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { mobileDeviceCheck } from '@helpers/mobile-check.helper';
import { ToastrService } from 'ngx-toastr';
import { AddressType, DefaultGUID, GroundResponseTimeOptions, RegionNames, RegionOptions } from 'src/app/@shared/constants/Constant';
import { CustomerPayload, CustomerType } from 'src/app/service/customer.model';
import { FilesService } from 'src/app/service/files.service';
import { MemberService } from 'src/app/service/member.service';
import { PartnerService } from 'src/app/service/partner.service';
import { ServiceRequestService } from 'src/app/service/service-request.service';
import { StateViewModel } from 'src/app/service/state.model';
import { VendorService } from 'src/app/service/vendor.service';
import { PartnerPayload, PartnerType } from '../../service/partner.model';
import { CustomerService } from '@services/customer.service';
declare var $: any;
@Component({
  selector: 'app-customer',
  templateUrl: './customerEdit.component.html',
  styleUrls: ['./customerEdit.component.css'],
})
export class CustomerEditDialogComponent implements OnInit {
  @ViewChild('fileInput') fileInput: ElementRef;
  public customer: CustomerPayload | PartnerPayload = {
    name: '',
    opo: '',
    partnerType: '',
    customerType: '',
    region: '',
    poBox: {},
    isContracted: false,
    groundResponseTime: 90,
    contact: {
      emailId: '',
      businessEmail: '',
      phone: '',
      primaryContact: '',
      emergencyContact: '',
    },
    address: {
      addressId: DefaultGUID,
      streetAddress: '',
      city: '',
      stateId: '',
      zipcode: '',
      latitude: '',
      longitude: '',
      addressLocationType: null,
      isGlobal: true,
    },
    files: [],
  };
  public cmrType: CustomerType[] = [];
  public regionOptions = RegionOptions;
  public groundResponseTimeOptions = GroundResponseTimeOptions;
  public searchText1: string = '';
  public stateList: StateViewModel[] = [];
  public cityList = [];
  public types: PartnerType[] = [];
  public poBoxValue: string = '';
  public poMappingLoader: Boolean = true;
  public AddressType: string[] = AddressType;
  constructor(
    private _toast: ToastrService,
    private vendorService: VendorService,
    private customerService: CustomerService,
    private partnerService: PartnerService,
    private _srService: ServiceRequestService,
    private _fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA)
    public data: Partial<{ header: string; customerDetail: any; index: number; chooseFile: any; selectedPartnerIndex: number }>,
    private _dialogRef: MatDialogRef<CustomerEditDialogComponent>,
    private _fileService: FilesService,
    private _memberService: MemberService,
  ) {}

  getStateList() {
    this.vendorService.getStateList().subscribe(
      (response) => {
        this.stateList = response;
      },
      (error) => {
        console.log(error);
      },
    );
  }
  getPartnerType() {
    this.partnerService.getAllPartnerType().subscribe(
      (response) => {
        this.types = response;
      },
      (error) => {
        console.log(error);
      },
    );
  }
  public selectedState: string = '';
  getCityByState(stateId: string) {
    if (stateId != undefined && stateId != '') {
      const state = this.stateList.find((x) => x.stateId == stateId);
      this.selectedState = state ? state.stateName : '';
      this.vendorService.getCityByState(stateId).subscribe((response) => {
        this.cityList = response;
      });
    }
  }

  getCustomerType() {
    this.vendorService.getCustomerType().subscribe(
      (response) => {
        this.cmrType = response;
      },
      (error) => {
        console.log(error);
      },
    );
  }
  public isMobileDevice = true;

  public loader = false;
  ngOnInit() {
    this.isMobileDevice = mobileDeviceCheck();
    this.getStateList();
    this.data.header.includes('Customer') ? this.getCustomerType() : this.getPartnerType();
    this.generatePOForm();
    this.assignValue();
  }

  assignValue() {
    this.oldFile = [];
    this.data.header == 'Edit Customer' || this.data.header == 'Edit Partner'
      ? this.getCityByState(this.data.customerDetail.address.stateId)
      : null;
    if (this.data.header == 'Edit Customer') {
      if (this.data.customerDetail.contact.businessEmail != null) {
        let email = String(this.data.customerDetail.contact.businessEmail).split(',');
        let newEmail: string[] = [];
        email.forEach((x) => {
          if (x != '') {
            x = x.trim();
            newEmail.push(x);
          }
        });
        this.data.customerDetail.contact.businessEmail = newEmail.toString();
      }

      this.customer = {
        name: this.data.customerDetail.name,
        opo: this.data.customerDetail.opo,
        customerType: this.data.customerDetail.customerTypeName,
        region: this.data.customerDetail.region,
        poBox: this.data.customerDetail.poBox,
        contact: {
          emailId: this.data.customerDetail.contact.emailId,
          businessEmail: this.data.customerDetail.contact.businessEmail,
          phone: this.data.customerDetail.contact.phone,
          primaryContact: this.data.customerDetail.contact.primaryContact,
          emergencyContact: this.data.customerDetail.contact.emergencyContact,
        },
        address: {
          addressId: this.data.customerDetail.address.addressId,
          streetAddress: this.data.customerDetail.address.streetAddress,
          city: this.data.customerDetail.address.city,
          stateId: this.data.customerDetail.address.stateId,
          zipcode: this.data.customerDetail.address.zipcode,
          latitude: '',
          longitude: '',
          addressLocationType: this.data.customerDetail.address.addressLocationType,
          isGlobal: this.data.customerDetail.address.isGlobal,
        },
        isContracted: this.data.customerDetail.isContracted ?? false,
        groundResponseTime: this.data.customerDetail.groundResponseTime,
      };
      if (this.data.customerDetail.contact.businessEmail) {
        this.associatedEmailList = this.data.customerDetail.contact.businessEmail.split(',');
      } else {
        this.associatedEmailList = [];
      }
      if (this.customer.poBox != null && this.customer.poBox != undefined) {
        this.poBoxValue = this.setPOValue(this.customer.poBox);
      }
    } else if (this.data.header == 'Edit Partner') {
      this.customer = {
        customerId: this.data.customerDetail.customerId,
        name: this.data.customerDetail.name,
        partnerType: this.data.customerDetail.partnerType,
        poBox: this.data.customerDetail.poBox,
        contact: {
          emailId: this.data.customerDetail.contact.emailId,
          businessEmail: this.data.customerDetail.contact.businessEmail,
          phone: this.data.customerDetail.contact.phone,
          primaryContact: this.data.customerDetail.contact.primaryContact,
          emergencyContact: this.data.customerDetail.contact.emergencyContact,
        },
        address: {
          addressId: this.data.customerDetail.address.addressId,
          streetAddress: this.data.customerDetail.address.streetAddress,
          city: this.data.customerDetail.address.city,
          stateId: this.data.customerDetail.address.stateId,
          zipcode: this.data.customerDetail.address.zipcode,
          addressLocationType: this.data.customerDetail.address.addressLocationType,
          isGlobal: this.data.customerDetail.address.isGlobal,
        },
        files: [],
        isContracted: false,
        groundResponseTime: this.data.customerDetail.groundResponseTime,
      };
      if (this.customer.poBox != null && this.customer.poBox != undefined) {
        this.poBoxValue = this.setPOValue(this.customer.poBox);
      }
    } else {
      this.resetCustomerData();
      this.poBoxValue = '';
    }
  }
  public setPOValue(customerPOValue): string {
    let poValue: string = '';
    let poKeys = Object.keys(customerPOValue);
    poKeys.map((x) => {
      if (this.customer.poBox[x] != '') {
        poValue += this.customer.poBox[x] + ', ';
      }
    });
    poValue = poValue.slice(0, poValue.length - 2);
    return poValue;
  }

  closeModel() {
    this.invalidEmail = false;
    this.resetAssociatedEmail();
  }
  public phoneNoRegex = /^\d{10}$/;

  updateCustomerDetail(event) {
    if (event.form.valid && !this.invalidEmail) {
      $('#addEditCustomer').modal('hide');
      if (this.data.header == 'Edit Customer') {
        this.loader = true;
        this.customerService.updateCustomerDetail(this.customer, this.data.customerDetail.customerId).subscribe((response) => {
          this.invalidEmail = false;
          this._toast.success('Record Updated Successfully', 'Record Updated', { timeOut: 2000, positionClass: 'toast-top-center' });
          if (this._memberService.customerList$.value.length > 0) {
            const index = this._memberService.customerList$.value.findIndex(
              (customer) => customer.customerID == this.data.customerDetail.customerId,
            );
            if (index !== -1) {
              this._memberService.customerList$.value[index].region = this.customer['region'];
            }
          }
          this._dialogRef.close('refresh');
        });
      } else {
        this.loader = true;
        this.partnerService.editPartner(this.data.customerDetail.partnerId, this.customer).subscribe((response) => {
          this.data.selectedPartnerIndex = this.data.customerDetail.partnerId;
          event.resetForm();
          if (this.data.chooseFile.length > 0) {
            if (this.copyArr.length > 0) {
              for (let index = 0; index < this.data.chooseFile.length; index++) {
                this.data.chooseFile[index].IsEditable = false;
                this.data.chooseFile[index].fileName = this.copyArr[index].fileName;
                this.data.chooseFile[index].fileType = this.copyArr[index].fileType;
                let arr = this.data.chooseFile.map((x) => x.IsEditable);
                if (arr.indexOf(true) == -1) this.editAllFile1 = false;
              }
            }
          }
          this.submitMultipleFile();
          this._dialogRef.close('refresh');
        });
      }
    }
  }

  addCustomer(event) {
    if (event.form.valid) {
      if (this.customer['region'] == RegionNames.LifeSource) {
        this._toast.warning('This region is no longer available. Please select another region.', 'Invalid Region', {
          timeOut: 2000,
          positionClass: 'toast-top-center',
        });
        return;
      }
      this.loader = true;
      $('#addEditCustomer').modal('hide');
      this.customer.contact.phone = this.customer.contact.phone.replace(/[^0-9\s]/g, '');
      this.customer.contact.phone = this.customer.contact.phone.replace(/\s/, '');
      if (this.customer.contact.emergencyContact != null && this.customer.contact.emergencyContact != '') {
        this.customer.contact.emergencyContact = this.customer.contact.emergencyContact.replace(/[^0-9\s]/g, '');
        this.customer.contact.emergencyContact = this.customer.contact.emergencyContact.replace(/\s/, '');
      }
      this.customer.contact.primaryContact = this.customer.contact.primaryContact.replace(/[^0-9\s]/g, '');
      this.customer.contact.primaryContact = this.customer.contact.primaryContact.replace(/\s/, '');
      let countryName = 'USA';
      let address =
        this.customer.address.streetAddress +
        ', ' +
        this.customer.address.city +
        ', ' +
        this.selectedState +
        ' ' +
        countryName +
        ' ' +
        this.customer.address.zipcode;
      var geocoder = new google.maps.Geocoder();
      let tempThis = this;

      geocoder.geocode(
        {
          address: address,
        },
        function (results, status) {
          if (status == 'OK') {
            let longitude = results[0].geometry.location.lng();
            let latitude = results[0].geometry.location.lat();
            if (longitude && latitude) {
              tempThis.customer.address['latitude'] = latitude.toString();
              tempThis.customer.address['longitude'] = longitude.toString();
            }

            tempThis.customerService.addCustomer(tempThis.customer).subscribe(
              (response) => {
                event.resetForm();
                tempThis._toast.success('Customer Added Successfully', 'Record Saved', {
                  timeOut: 2000,
                  positionClass: 'toast-top-center',
                });
                tempThis.loader = false;
                tempThis._dialogRef.close('refresh');
              },
              (error) => {
                tempThis.loader = false;
                console.log(error);
              },
            );
          } else {
            tempThis.loader = false;
            tempThis._toast.error('Location not found! Please check your address.', 'Error', {
              timeOut: 6000,
              positionClass: 'toast-top-center',
            });
          }
        },
      );
    }
  }

  @Output() editPartnerGridValue = new EventEmitter();
  addPartner(event) {
    if (event.form.valid) {
      this.loader = true;
      this.customer['customerId'] = this.data.customerDetail.customerId;
      this.customer.contact.phone = this.customer.contact.phone.replace(/[^0-9\s]/g, '');
      this.customer.contact.phone = this.customer.contact.phone.replace(/\s/, '');
      if (this.customer.contact.emergencyContact != null && this.customer.contact.emergencyContact != '') {
        this.customer.contact.emergencyContact = this.customer.contact.emergencyContact.replace(/[^0-9\s]/g, '');
        this.customer.contact.emergencyContact = this.customer.contact.emergencyContact.replace(/\s/, '');
      }
      this.customer.contact.primaryContact = this.customer.contact.primaryContact.replace(/[^0-9\s]/g, '');
      this.customer.contact.primaryContact = this.customer.contact.primaryContact.replace(/\s/, '');
      this.partnerService.createPartner(this.customer).subscribe((response) => {
        event.resetForm();
        this.multipleFileAttach(response, this.data.chooseFile, 'partner');
        this._dialogRef.close('refresh');
      });
      $('#addEditCustomer').modal('hide');
    }
  }

  selectedAircraftFileType: any = 'All';
  fileEdit(index, file) {
    this.copyArr = [...this.data.chooseFile];
    this.data.chooseFile[index].IsEditable = true;
  }
  openFile() {
    $('#partnerFileUpload').click();
  }
  public partnerFile: any;
  public copyArr = [];
  public reg = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
  closeDisable(index) {
    this.data.chooseFile[index].IsEditable = false;
    this.data.chooseFile[index].fileName = this.copyArr[index].fileName;
    this.data.chooseFile[index].fileType = this.copyArr[index].fileType;
    let arr = this.data.chooseFile.map((x) => x.IsEditable);
    if (arr.indexOf(true) == -1) this.editAllFile1 = false;
  }
  public editAllFile1: boolean = false;
  updateFileData(index) {
    this.data.chooseFile[index].IsEditable = false;
  }
  resetForm(loginForm: any) {
    loginForm.resetForm();
    this.resetAssociatedEmail();
  }

  public url: string;
  public selectedFileName: string;

  readUrl1(input) {
    var tempThis = this;
    this.url = '';
    this.selectedFileName = '';
    if (input.files && input.files[0]) {
      this.selectedFileName = input.files[0].name;
      var reader = new FileReader();

      reader.onload = function (e) {
        let target: any = e.target; //<-- This (any) will tell compiler to shut up!
        tempThis.url = target.result;
        tempThis.data.chooseFile.push({
          fileId: tempThis.data.chooseFile.length,
          fileType: '',
          fileName: tempThis.selectedFileName.split('.')[0],
          extension: tempThis.selectedFileName.split('.')[1],
          IsEditable: false,
          picture: tempThis.url,
        });
      };
      reader.readAsDataURL(input.files[0]);
    }
  }

  editAllFile() {
    this.copyArr = [...this.data.chooseFile].map((item) => ({ ...item }));
    this.data.chooseFile.forEach((item) => {
      item.IsEditable = true;
    });
    this.editAllFile1 = true;
  }

  closeViewFileModel(flag) {
    this.data.chooseFile.forEach((item) => {
      if (flag) item['fileName'] = item['fileName'] + '.' + item['extension'];
      item.IsEditable = false;
    });
    this.editAllFile1 = false;
  }
  closeAll() {
    this.editAllFile1 = false;
  }
  errorMessage(mag) {
    this._toast.error(mag, 'Error', { timeOut: 2000, positionClass: 'toast-top-center' });
  }
  partnerFileUpload(name, fileId) {
    let tempFileList = $('#' + fileId)[0].files;
    let tempFileListArray = Array.from(tempFileList);
    tempFileListArray.forEach((file) => {
      file['fileId'] = 0;
      file['fileType'] = ' ';
      file['displayName'] = file['name'];
      file['extension'] = file['type'].split('/')[1];
      file['fileName'] = file['name'].split('.')[0];
      file['IsEditable'] = false;
      this.data.chooseFile.push(file);
    });
    this.fileInput.nativeElement.value = '';
  }
  public path: string = '';
  public multipleFilePopup: any;
  public multipleFileUpload: any;

  multipleFileAttach(memberId, fileList, flag?) {
    let accessToken = localStorage.getItem('AccessToken');
    if (fileList.length != 0) {
      this.path = '';
      this.multipleFileUpload = new FormData();
      fileList.forEach((item) => {
        this.path = this.path.concat(item.fileType + ',');
        this.multipleFileUpload.append(item.name, item);
      });
      this.path = this.path.replace(/,(?=\s*$)/, '');
      this._fileService.uploadFile(this.path, 'Partner', memberId, this.multipleFileUpload).subscribe(
        (response) => {
          if (flag == 'partner') {
            this.loader = false;
            this.editPartnerGridValue.emit();
            this._toast.success('Record Added Successfully', 'Record Saved', { timeOut: 2000, positionClass: 'toast-top-center' });
          } else {
            this.editFile();
          }
        },
        (error) => {
          this.loader = false;
          console.log(error.responseJSON.message);
        },
      );
    } else {
      this.editFile();
    }
  }
  public oldFile = [];
  public deletedFile = [];

  submitMultipleFile() {
    this.oldFile = [];
    this.data.chooseFile.forEach((item) => {
      item['displayName'] = item['fileName'] + '.' + item['extension'];
      if (item.fileId != 0) {
        this.oldFile.push({
          fileId: item.fileId,
          fileName: item.displayName,
          fileType: item.fileType,
        });
      }
    });

    let newFile = this.data.chooseFile.filter((x) => x.fileId == 0);
    this.multipleFileAttach(this.data.selectedPartnerIndex, newFile);
  }

  deleteFile() {
    if (this.deletedFile.length != 0) {
      let deleteFile = '';
      this.deletedFile.forEach((item) => {
        deleteFile = deleteFile + 'fileId=' + item.fileId + '&';
      });
      deleteFile = deleteFile.slice(0, -1);
      this.vendorService.deletedFile(deleteFile).subscribe((response) => {
        this.deletedFile = [];
      });
    } else {
      this._toast.success('Record Added Successfully', 'Record Saved', { timeOut: 2000, positionClass: 'toast-top-center' });
      this.editPartnerGridValue.emit();
    }
    this.loader = false;
  }
  editFile() {
    if (this.oldFile.length != 0) {
      this.vendorService.editFile(this.oldFile).subscribe((response) => {
        this.oldFile = [];
        this.deleteFile();
      });
    } else {
      this.deleteFile();
    }
  }
  removeFileForPopup(index) {
    if (this.data.chooseFile[index].fileId != 0) this.deletedFile.push(this.data.chooseFile[index]);
    this.data.chooseFile.splice(index, 1);
    this._toast.success('Removed File Successfully!', 'Success', {
      timeOut: 6000,
      positionClass: 'toast-top-center',
    });
  }

  public associatedEmailList: string[] = [];
  public showField: boolean = false;

  associatedEmail(type: string) {
    if (type == 'add') {
      this.associatedEmailList.push('');
    }
    if (type == 'remove') {
      this.associatedEmailList.pop();
    }
  }
  show(selectedItem: string) {
    this.selectedEmail = selectedItem;
    this.email = this.selectedEmail;
  }
  removeSelectedEmail() {
    let index = this.associatedEmailList.findIndex((x) => x == this.selectedEmail);
    if (index > -1) {
      this.associatedEmailList.splice(index, 1);
      this.selectedEmail = undefined;
      this.email = '';
    }
    if (this.associatedEmailList.length == 0) {
      this.selectedEmail = undefined;
      this.email = '';
      this.associatedEmailList = [];
      this.showField = false;
    }
    $('#addEditCustomer').modal('show');
  }
  public email: string;
  saveEmail(event: any) {
    let index;
    if (event.target.value != '') {
      this.associatedEmailList.push(event.target.value);
    }

    let arr = [];
    this.associatedEmailList.forEach((x) => {
      if (x != '') {
        arr.push(x);
      }
    });
    this.customer.contact.businessEmail = arr.join(',');
    this.showField = false;
    this.email = '';
    this._toast.success('added to business email to the list successfully.', '', {
      positionClass: 'toast-top-center',
      timeOut: 2000,
    });
  }
  public selectedEmail: string = undefined;
  editEmail() {
    this.email = this.selectedEmail;
    this.showField = true;
    let index = this.associatedEmailList.indexOf(this.email);
    if (index > -1) this.associatedEmailList.splice(index, 1);
  }
  resetAssociatedEmail() {
    this.email = '';
    this.selectedEmail = undefined;
    this.associatedEmailList = [];
    this.showField = false;
  }
  public invalidEmail: boolean = false;
  validateEmail(mail: string): boolean {
    mail = mail.trim();
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail) && mail.includes('.') && mail.includes('@')) {
      return true;
    }
    return false;
  }

  checkEmail(event): void {
    if (event.target.value.length > 0) {
      let tempEmails: string = event.target.value;
      let emails = tempEmails.split(',');
      for (let i = 0; i < emails.length; i++) {
        if (!this.validateEmail(emails[i])) {
          this.invalidEmail = true;
          break;
        } else {
          this.invalidEmail = false;
        }
      }
    }
  }
  poForm: UntypedFormGroup;
  generatePOForm() {
    this.poForm = this._fb.group({
      organType: this._fb.array([]),
    });
  }
  get organType(): UntypedFormArray {
    return this.poForm.get('organType') as UntypedFormArray;
  }
  openPOModel() {
    this.poMappingLoader = true;
    this.generatePOForm();
    this._srService.getOrganTypes().subscribe(
      (response) => {
        if (response != null && response != undefined) {
          response.forEach((item: any) => {
            let formGroup = this._fb.group({
              organType: item.organTypeValue,
              organTypeValue:
                this.customer.poBox != null
                  ? Object.keys(this.customer.poBox).length > 0
                    ? this.customer.poBox[item.organTypeValue]
                    : ''
                  : '',
            });
            this.organType.push(formGroup);
            this.poMappingLoader = false;
          });
        }
      },
      (error) => {
        this._toast.warning('Something went wrong! Please try again', 'Warning', { timeOut: 6000, positionClass: 'toast-top-center' });
        console.log(error);
        this.poMappingLoader = false;
      },
    );
  }

  savePO() {
    if (this.customer.poBox == null) {
      let poBoxObject: Object = {};
      this.organType.controls.forEach((element) => {
        poBoxObject[element.value.organType] = element.value.organTypeValue;
      });
      this.customer.poBox = poBoxObject;
    } else {
      this.organType.controls.forEach((element) => {
        this.customer.poBox[element.value.organType] = element.value.organTypeValue;
      });
    }
    this.poBoxValue = this.setPOValue(this.customer.poBox);
  }

  public selectedRegion(region): void {
    this.customer['region'] = region.target.value;
  }

  public resetCustomerData() {
    this.customer = {
      customerId: DefaultGUID,
      name: '',
      partnerType: '',
      customerType: '',
      poBox: {},
      region: '',
      contact: {
        emailId: '',
        businessEmail: '',
        phone: '',
        primaryContact: '',
        emergencyContact: '',
      },
      address: {
        addressId: DefaultGUID,
        streetAddress: '',
        city: '',
        stateId: '',
        zipcode: '',
        addressLocationType: null,
        isGlobal: true,
      },
      files: [],
      isContracted: false,
      groundResponseTime: 90,
    };
  }
}
